module.exports = "/packs/course-small-business-82408b1321d44e1d623dc2bed7c1d655.png";